import { Check } from "lucide-react";

const POINTS = [
  "Sektionsfällning vid trånga lägen",
  "Kranbilsfällning när det behövs",
  "Traditionell markfällning när platsen tillåter",
  "Stubbfräsning och bortforsling efteråt",
  "Tydlig offert innan arbetet startar",
];

export default function TrustSection() {
  return (
    <section
      data-testid="trust-section"
      className="section-pad bg-[#1B2A1E] text-[#F7F5F0] tf-grain relative overflow-hidden"
    >
      <div className="absolute inset-0 opacity-30 pointer-events-none">
        <img
          src="/images/tradvard.webp"
          alt=""
          loading="lazy"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#1B2A1E] via-[#1B2A1E]/95 to-[#1B2A1E]/40" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <div className="lg:col-span-7">
            <span className="eyebrow !text-[#F2A57C]">Trygghet</span>
            <h2 className="mt-4 font-heading text-3xl sm:text-4xl lg:text-5xl font-extrabold leading-tight tracking-tight">
              Trygg hjälp när trädet står svårt till
            </h2>
            <p className="mt-5 text-[#D9DCD3] text-lg leading-relaxed max-w-2xl">
              Träd nära hus, garage, ledningar, vägar eller tomtgränser kräver
              rätt metod och rätt utrustning. Vi arbetar metodiskt och anpassar
              varje uppdrag efter platsen, trädets storlek och omgivningen.
            </p>
          </div>

          <ul className="lg:col-span-5 space-y-3">
            {POINTS.map((p, i) => (
              <li
                key={p}
                data-testid={`trust-point-${i + 1}`}
                className="tf-reveal flex items-start gap-3 bg-white/5 backdrop-blur-sm border border-white/10 rounded-lg px-4 py-3.5"
                style={{ transitionDelay: `${i * 70}ms` }}
              >
                <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-[#D95D2E] text-white shrink-0 mt-0.5">
                  <Check className="w-3.5 h-3.5" strokeWidth={3} />
                </span>
                <span className="text-[#F7F5F0] font-medium leading-relaxed">
                  {p}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
